/**
 * Serializes a JSON-LD payload for a <script type="application/ld+json"> tag.
 *
 * Two traps this guards against:
 * - JSON.stringify(undefined) returns undefined (not a string) — the search
 *   results page builds its jsonlds array with conditional entries and an
 *   undefined slot used to reach the map; chaining .replace on it crashed the
 *   whole client render (blank page, MR !444 pipeline 32044). Undefined and
 *   null yield '' and the caller skips empty output.
 * - JSON.stringify leaves "<" intact, so a stored string containing
 *   "</script>" would terminate this very tag and execute as a new script
 *   (JSON-LD injection — user_expertise.alias_title flows here unvalidated).
 *   Escaping "<" keeps the JSON semantically identical.
 */
export const stringifyJsonLd = (item: unknown): string => {
  const json = JSON.stringify(item);
  return typeof json === 'string' ? json.replace(/</g, '\\u003c') : '';
};
